import RootProvider from './RootProvider';

export default RootProvider;
